module.exports = __webpack_public_path__ + "static/img/zhaopin.4b3ad07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zhaopin.png
// module id = CinL
// module chunks = 171